import React from 'react';
import PropTypes from 'prop-types';
import "./Socials.scss";
import Social from "./Social";

const Socials = ({ socials }) => {

  const authLinks = {
    facebook: "https://www.facebook.com/dialog/oauth?client_id=264853881772555&scope=email&redirect_uri=",
    vkontakte: "https://oauth.vk.com/authorize?client_id=7796095&response_type=code&scope=email&redirect_uri=",
    odnoklassniki: "https://www.odnoklassniki.ru/oauth/authorize?client_id=512000797094&response_type=code&scope=GET_EMAIL&redirect_uri=",
    mailru: "https://connect.mail.ru/oauth/authorize?client_id=783548&response_type=code&redirect_uri=",
    google: "",
    yandex: "https://oauth.yandex.ru/authorize?response_type=code&client_id=583d3f3de667408fb27c0c7766dfce40&redirect_uri="
  };

  const auth = social => {
    localStorage.setItem("authSocial", social);
    let path = authLinks[social] + window.location.protocol + "//" + window.location.hostname;
    if (window.location.hostname === "localhost") path += ":" + window.location.port;
    path += window.location.pathname;
    window.location.href = path;
  };

  return (
    <div className={"socials"}>
      {socials.map(social => <Social key={social} social={social} onClick={() => auth(social)} />)}
    </div>
  );

};

Socials.propTypes = {
  socials: PropTypes.array.isRequired
};

export default Socials;
